import React, { Component } from "react";
// import { Modal } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
import ModalHelpers from "./ModalHelpers";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import TraffickingDataStore from "../../Flux/Stores/TraffickingDataStore";
import { submitTraffickingRequest, fetchTraffickingRequestCampaigns } from "../../Flux/Actions/TraffickingActions";
import LoadingIcon from "../../Components/LoadingSpinner";
import Textbox from "@acadia-ui/textbox";
import DatePicker from "@acadia-ui/datepicker";
import Dropdown from "@acadia-ui/dropdown";
import "./traffickingModal.scss";
import "./modal.scss";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";

const initialState = {
	liveDate: new Date(),
	priority: { label: "N/A", value: "na" },
	invoice: "",
	notes: "",
	showErrors: false,
	errors: {},
	loading: false
};

class TraffickingRequestModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			...initialState,
			open: false,
			loading: false,
			priorityOptions: [
				{ label: "N/A", value: "N/A" },
				{ label: "Low", value: "Low" },
				{ label: "Medium", value: "Medium" },
				{ label: "High", value: "High" }
			],
			placementEndDateError: false,
			minLiveDate: null,
			maxLiveDate: null,
			formEl: `${props.hierarchyLevel}_trafficking_request_modal`
		};
	}

	componentDidMount() {
		this.props.traffickingModal(this);
		// TraffickingDataStore.on("submit_trafficking_success", this.triggerOpenClose);
		TraffickingDataStore.on("submit_trafficking_redirect", this.traffickingRedirect);
		TraffickingDataStore.on("submit_trafficking_fail", this.displayErrors);
		TraffickingDataStore.on("edit_trafficking_success", this.fetchCampaigns);
		TraffickingDataStore.on("edit_trafficking_fail", this.displayErrors);
	}

	componentWillUnmount() {
		this.props.traffickingModal(undefined);
		// TraffickingDataStore.removeListener("submit_trafficking_success", this.triggerOpenClose);
		TraffickingDataStore.removeListener("submit_trafficking_redirect", this.traffickingRedirect);
		TraffickingDataStore.removeListener("submit_trafficking_fail", this.displayErrors);
		TraffickingDataStore.removeListener("edit_trafficking_success", this.fetchCampaigns);
		TraffickingDataStore.removeListener("edit_trafficking_fail", this.displayErrors);
	}

	fetchCampaigns = () => {
		fetchTraffickingRequestCampaigns().then(() => {
			this.triggerOpenClose();
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		ErrorHelpers.resetErrors(this.state.formEl);
		this.setState({ ...initialState, open: !this.state.open });
		!this.state.open ? Modal.show(this.state.formEl) : Modal.hide(this.state.formEl);
	};

	updateModalState = () => {
		this.setState({ open: !this.state.open });
	};

	traffickingRedirect = () => {
		const contextValues = BookFiltersStore.getContextValues();
		const TRAFFICKING_URL = process.env.REACT_APP_TRAFFICKING_URL;
		const campaignId = this.props.campaignMetaData.CampaignUniqueIDCode;
		const redirectId = TraffickingDataStore.getRedirectID();
		location.href = `${TRAFFICKING_URL}/TraffickingDirect/${campaignId}/${redirectId}?context_id=${contextValues.contextId}`;
	};

	sendTraffickingPlacements = (e, redirect) => {
		e.preventDefault();

		const { selectedRows, hierarchyLevel, campaignMetaData } = this.props;
		const { notes, liveDate, invoice, priority } = this.state;

		const postObj = {
			HierarchyLevelKeyIDS: selectedRows.map((row) => parseInt(row[`${hierarchyLevel}ID`], 10)),
			AdditionalNotes: notes,
			CreativeDirectionDueDate: "",
			TrafficLiveDate: liveDate,
			BillingInvoiceCode: invoice,
			Priority: priority.label
		};

		this.setState({ loading: true }, () => {
			submitTraffickingRequest(campaignMetaData.CampaignUniqueIDCode, postObj, hierarchyLevel, redirect);
		});
	};

	formatDate = (date) => {
		if (date) {
			const formattedDate = new Date(date);
			return formattedDate.toLocaleDateString();
		}
		return null;
	};

	displayErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = TraffickingDataStore.getTrafficRequestErrors();
			if (Object.keys(errors).length > 0) {
				const traffickingErrors = errors;
				const type = "trafficking request";
				this.setState({ errors: traffickingErrors, showErrors: true }, () => {
					ErrorHelpers.displayErrors(this.state.formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Traffic request could not be submitted." />);
				});
			}
		});
	};

	disableSubmit = () => {
		const { liveDate, placementEndDateError, notes } = this.state;

		try {
			if (liveDate === null || placementEndDateError || notes?.trim() == "") {
				return true;
			}
			return false;
		} catch {
			return true;
		}
	};

	setLiveDateRestrictions = (dates) => {
		const today = new Date();
		const maxLiveDate = new Date(dates.EarliestPlacementEndDate);
		const minLiveDate = dates.LatestTraffickingRequestLiveDate ? new Date(dates.LatestTraffickingRequestLiveDate) : today;
		maxLiveDate.setHours(0, 0, 0, 0);
		minLiveDate.setHours(0, 0, 0, 0);
		let placementEndDateError = false;
		if (dates.EarliestPlacementEndDate && dates.LatestTraffickingRequestLiveDate) {
			const formattedTRLD = new Date(dates.LatestTraffickingRequestLiveDate);
			formattedTRLD.setHours(0, 0, 0, 0);
			if (maxLiveDate < formattedTRLD) {
				placementEndDateError = true;
			}
		}
		this.setState({ minLiveDate, maxLiveDate, placementEndDateError }, () => {
			this.triggerOpenClose();
		});
	};

	render() {
		const today = new Date();

		return (
			<Modal
				id={this.state.formEl}
				heading="Start traffic request"
				description={this.props.campaignJIRATicket ? "Send the selected placements to the assigned recipient:" : ""}
				onClick={() => {}}
				onRequestClose={this.triggerOpenClose}
				actionSetProps={{
					actionsRight: (
						<>
							<Button
								disabled={this.disableSubmit()}
								display={BUTTON_DISPLAY.SECONDARY}
								onClick={(e) => this.sendTraffickingPlacements(e, false)}
								data-tracking-id-alt="submit-trafficking-request"
							>
								Submit
							</Button>
							<Button
								disabled={this.disableSubmit()}
								onClick={(e) => this.sendTraffickingPlacements(e, true)}
								data-tracking-id-alt="submit-trafficking-request-move-to-next-step"
							>
								Submit and move to next step
							</Button>
						</>
					)
				}}
			>
				{this.props.campaignJIRATicket === false && <span style={{ color: "red" }}>Error. Valid JIRA ticket not found. Contact product support.</span>}
				{this.state.placementEndDateError && <span style={{ color: "red" }}>Please ensure all placements end dates are after selected live date.</span>}
				<DatePicker
					id={`${this.state.formEl}requestLiveDate`}
					value={this.state.liveDate}
					onChange={(selected) => this.setState({ liveDate: selected })}
					disabled={!this.props.campaignJIRATicket}
					required={true}
					invert
					minDate={this.state.minLiveDate ? this.state.minLiveDate : today}
					maxDate={this.state.maxLiveDate ? this.state.maxLiveDate : null}
				>
					Live date
				</DatePicker>
				<span style={{ height: "55px", lineHeight: "23px" }} className={`errors__TrafficLiveDate`} />
				<div>
					<Dropdown
						id={`${this.state.formEl}requestPriority`}
						value={this.state.priority}
						options={this.state.priorityOptions}
						defaultValue={this.state.priorityOptions[0]}
						onChange={(selected) => this.setState({ priority: selected })}
						placeholder="Priority"
						invert={true}
						isSearchable={true}
						disabled={!this.props.campaignJIRATicket}
					>
						Priority (Optional)
					</Dropdown>
					<span style={{ height: "55px", lineHeight: "23px" }} className={`errors__Priority`} />
				</div>
				<div>
					<Textbox
						className="traffickingTextArea"
						id={`${this.state.formEl}requestInvoice`}
						as="textarea"
						value={this.state.invoice}
						invert={true}
						placeholder="Invoice code (128 Character Limit)"
						maxLength="128"
						onChange={(evt) => this.setState({ invoice: evt.target.value })}
						style={{ height: "100px" }}
						disabled={!this.props.campaignJIRATicket}
					>
						Invoice code (Optional)
					</Textbox>
					<span style={{ height: "55px", lineHeight: "23px" }} className={`errors__BillingInvoiceCode`} />
				</div>
				<div>
					<Textbox
						className="traffickingTextArea"
						id={`${this.state.formEl}requestComment`}
						as="textarea"
						value={this.state.notes}
						required={true}
						invert={true}
						placeholder="Comment/Notes (250 Character Limit)"
						maxLength="250"
						onChange={(evt) => this.setState({ notes: evt.target.value })}
						style={{ height: "100px" }}
						disabled={!this.props.campaignJIRATicket}
					>
						Comment
					</Textbox>
					<span style={{ height: "55px", lineHeight: "23px" }} className={`errors__AdditionalNotes`} />
				</div>
				{this.state.loading && <LoadingIcon />}
				{this.state.showErrors && <div id="errors__container" />}
			</Modal>
		);
	}
}

export default TraffickingRequestModal;
